import React from 'react';
import { Link } from 'react-router-dom';
import { Shield, Phone, Mail, MapPin, Facebook, Twitter, Linkedin, Instagram } from 'lucide-react';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <footer className="bg-gray-900 text-gray-300 overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid md:grid-cols-4 gap-12 mb-12">
          {/* Company Info */}
          <div className="min-w-0">
            <div className="flex items-center space-x-2 mb-6">
              <Shield className="h-8 w-8 text-blue-400 flex-shrink-0" />
              <span className="text-xl sm:text-2xl font-bold text-white break-words">trademark website name</span>
            </div>
            <p className="text-gray-400 leading-relaxed mb-6">
              Your trusted partner for comprehensive trademark registration services across the United States.
            </p>
            <div className="flex space-x-4">
              <a href="#" className="bg-gray-800 p-2 rounded-lg hover:bg-blue-600 transition-colors duration-300">
                <Facebook className="h-5 w-5" />
              </a>
              <a href="#" className="bg-gray-800 p-2 rounded-lg hover:bg-blue-600 transition-colors duration-300">
                <Twitter className="h-5 w-5" />
              </a>
              <a href="#" className="bg-gray-800 p-2 rounded-lg hover:bg-blue-600 transition-colors duration-300">
                <Linkedin className="h-5 w-5" />
              </a>
              <a href="#" className="bg-gray-800 p-2 rounded-lg hover:bg-blue-600 transition-colors duration-300">
                <Instagram className="h-5 w-5" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div className="min-w-0">
            <h3 className="text-white text-lg font-bold mb-6">Quick Links</h3>
            <ul className="space-y-3">
              <li>
                <button onClick={scrollToTop} className="hover:text-blue-400 transition-colors duration-300">Home</button>
              </li>
              <li>
                <button onClick={scrollToTop} className="hover:text-blue-400 transition-colors duration-300">About Us</button>
              </li>
              <li>
                <button onClick={scrollToTop} className="hover:text-blue-400 transition-colors duration-300">Services</button>
              </li>
              <li>
                <button onClick={scrollToTop} className="hover:text-blue-400 transition-colors duration-300">Pricing</button>
              </li>
              <li>
                <button onClick={scrollToTop} className="hover:text-blue-400 transition-colors duration-300">Contact</button>
              </li>
            </ul>
          </div>

          {/* Services */}
          <div className="min-w-0">
            <h3 className="text-white text-lg font-bold mb-6">Our Services</h3>
            <ul className="space-y-3">
              <li className="hover:text-blue-400 transition-colors duration-300 cursor-pointer">Trademark Search</li>
              <li className="hover:text-blue-400 transition-colors duration-300 cursor-pointer">Trademark Filing</li>
              <li className="hover:text-blue-400 transition-colors duration-300 cursor-pointer">Office Actions</li>
              <li className="hover:text-blue-400 transition-colors duration-300 cursor-pointer">Trademark Monitoring</li>
              <li className="hover:text-blue-400 transition-colors duration-300 cursor-pointer">Brand Protection</li>
            </ul>
          </div>

          {/* Contact Info */}
          <div className="min-w-0">
            <h3 className="text-white text-lg font-bold mb-6">Contact Us</h3>
            <ul className="space-y-4">
              <li className="flex items-start space-x-3">
                <MapPin className="h-5 w-5 text-blue-400 flex-shrink-0 mt-1" />
                <span className="text-gray-400 text-sm sm:text-base break-words">500 N Brand Blvd #2000, Glendale, CA 91203</span>
              </li>
              <li className="flex items-center space-x-3">
                <Phone className="h-5 w-5 text-blue-400 flex-shrink-0" />
                <a href="tel:+11231234567" className="text-gray-400 hover:text-blue-400 transition-colors duration-300 text-sm sm:text-base">
                  +1 (123) 123-4567
                </a>
              </li>
              <li className="flex items-start space-x-3">
                <Mail className="h-5 w-5 text-blue-400 flex-shrink-0 mt-1" />
                <a href="mailto:info@trademarkwebsitename.com" className="text-gray-400 hover:text-blue-400 transition-colors duration-300 text-sm sm:text-base break-all">
                  info@trademarkwebsitename.com
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-800 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <p className="text-gray-400 text-sm text-center md:text-left break-words">
              © {currentYear} trademark website name. All rights reserved.
            </p>
            <div className="flex flex-wrap justify-center gap-4 md:gap-6 text-sm">
              <Link to="/privacy-policy" className="text-gray-400 hover:text-blue-400 transition-colors duration-300">
                Privacy Policy
              </Link>
              <Link to="/terms-conditions" className="text-gray-400 hover:text-blue-400 transition-colors duration-300">
                Terms & Conditions
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
